/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import ArtistiDetails from '../../userNotAuth/components/artistaDetails'

function ChildArtisti({ tipo, flag, flag2, flag3, flag4, dettagliIsOpen }) {
    const [artisti, setArtisti] = useState([])
    const [artista, setArtista] = useState({})
    const [formData, setFormData] = useState({
        genere: '',
        messaggio: null,
        userId: localStorage.getItem('id'),
        nomeMittente: localStorage.getItem('nome'),
        emailMittente: localStorage.getItem('email'),
        fotoMittente: localStorage.getItem('img'),
        fotoDestinatario: null,
        nomeDestinatario: ''
    })
    const [foto, setFoto] = useState([])
    const [msg, setMsg] = useState({ cerca: null })

    const messageSubmit = useRef()
    const description = useRef()
    const videoPreview = useRef()

    const details = { display: 'grid', gridTemplateColumns: '0.20fr 1fr', gap: '5px', marginTop: '1em' }

    async function getArtisti() {
        let rty
        try {
            const res = await axios.post(`/getArtisti/ASC/regione`)
            if (tipo === 'artisti') {
                rty = res.data.filter(item => item.sezione === "artista")
            }
            else {
                if (tipo === 'foodTruck') rty = res.data.filter(item => item.sezione === "truck")
            }
            setArtisti(rty)
        } catch (err) { console.log(err) }
    }
    async function dettagli(id, img, tipo) {
        dettagliIsOpen('secondoArtisti', tipo)
        setArtista(artisti.filter(x => x.id === id)[0])
        // setTextArea(artisti.filter(x => x.id === id)[0].descrizione)
        description.current.innerHTML = artisti.filter(x => x.id === id)[0].descrizione
        img && setFoto(img.split(','))
        try {
            await axios.post(`/incView/${parseInt(id)}/${formData.userId}`).then(res => {
            })
        } catch (err) { console.log(err) }
    }
    function handleChange(e) {
        const { name, value } = e.target
        setFormData({ ...formData, genere: value })
        if (name === 'messaggio') {
            if (!value.trim().length || value === '') {
                messageSubmit.current.style.display = 'none'
                setFormData({ ...formData, messaggio: null })
                return
            }
            messageSubmit.current.style.display = 'inline'//rendo visibile l'icona di invio messaggio
            setFormData({ ...formData, messaggio: value })
        }
    }
    useEffect(() => {
        if (formData.genere) {
            const x = artisti.filter(e => e.genere.toUpperCase().includes(formData.genere.toUpperCase()) ||
                e.soggetto && e.soggetto.toUpperCase().includes(formData.genere.toUpperCase()) ||
                e.regione.toUpperCase().includes(formData.genere.toUpperCase()))
            if (x.length === 0 && artisti.length !== 0) {
                setMsg({ cerca: `${tipo} non trovati` })
            }
            else setMsg({ cerca: null })
        }
    }, [formData.genere])

    useEffect(() => {
        if (flag === 'primoArtisti') {
            getArtisti()
            setFormData({ ...formData, pholder: tipo === 'artisti' ? "Genere artista es.'band rock' o regione" : 'Genere foodTruck es.Hamburger' })
            if (artista.video) {
                const lp = videoPreview.current
                lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
            }
        }
    }, [flag])

    return (<>
        <div className={`divNotifiche${flag === 'primoArtisti' || flag2 === 'secondoArtisti' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <div>
                <button style={{ fontSize: 'xx-large', border: 'none' }}
                    onClick={() => { window.history.back() }}
                >◀
                </button>

                <div className='mt-3 p-1'>
                    <input className="fw-bold rounded form-control"
                        style={{ border: '1px solid navy' }}
                        id='regione'
                        name='regione'
                        onChange={handleChange}
                        maxLength={30}
                        placeholder={formData.pholder}
                        type='text' />
                </div>
            </div><hr />

            <div className="mt-1 p-1 text-center" style={{ opacity: '.6' }}><i>{msg.cerca}</i></div>

            <div style={{ margin: '0 3px', overflowY: 'scroll', height: '78%' }}>
                {artisti && artisti.length !== 0 ?
                    artisti.filter(e => e.accettazione === 'true' && e.genere.toUpperCase().includes(formData.genere.toUpperCase()) === true
                        || e.soggetto && e.soggetto.toUpperCase().includes(formData.genere.toUpperCase()) === true ||
                        e.regione && e.regione.toUpperCase().includes(formData.genere.toUpperCase()) === true)
                        .map(artista => (
                            <div style={{ borderBottom: '1px solid lightgrey', display: 'grid', gridTemplateColumns: '1fr .8fr', gap: '5px', cursor: 'pointer', margin: '8px 0' }}
                                onClick={() => { dettagli(artista.id, artista.img, tipo) }} key={`${artista.id}art`}>
                                {tipo === 'artisti' ?
                                    <div style={{ fontWeight: '700' }}>
                                        {artista.nome || artista.cognome ? <span>{artista.nome} {artista.cognome}</span> :
                                            artista.gruppo ? <span> {artista.gruppo} </span> : ''}
                                    </div>
                                    : <div style={{ fontWeight: '700' }}>{artista.nome} </div>
                                }
                                <div style={{ fontSize: 'small' }}><i>{artista.genere}</i></div>
                            </div>
                        ))
                    : <p className='text-center'>Nessuna artista trovato</p>
                }
            </div>
        </div>
        {/* ------------------------ BANNER DETTAGLI ARTISTA/FOODTRUCK --------------------------- */}
        <div className={`divNotifiche${flag2 === 'secondoArtisti' || flag3 === 'terzoArtisti' || flag === 'artistaDetails' ? 'Aperto' : ''}`
        }
            style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={() => {
                    setFoto([])
                    if (artista.video) {
                        const lp = videoPreview.current
                        lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                    }
                    window.history.back()
                }}>◀
            </button><hr />

            <div style={{ margin: '1em 3px', overflowY: 'scroll', height: '85%' }}>
                <h4>{artista.nome} {tipo === 'artisti' && <span>{artista.cognome}</span>}</h4>
                <div className='mt-3'>
                    {artista.img ?
                        <img src={`https://leuro-bucket.s3.amazonaws.com/${artista.img.split(',')[0]}`} style={{ maxWidth: '200px', maxHeight: '150px', marginTop: '.5em' }} /> :
                        <img src={require('../../userNotAuth/image/icons8-impostazioni-amministratore-maschio-32.png')} />
                    }
                </div>

                {artista.gruppo && tipo === 'artisti' &&
                    <div style={details}>
                        <div>Gruppo:</div><div style={{ fontWeight: '600' }}>{artista.gruppo}</div>
                    </div>
                }
                {artista.genere &&
                    <div style={{ ...details, marginTop: '5px' }}>
                        <div>Genere:</div><div style={{ fontWeight: '600' }}>{artista.genere}
                            {artista.soggetto && <span style={{ fontWeight: '500', fontSize: 'small' }}> ({artista.soggetto})</span>}
                        </div>
                    </div>
                }
                {tipo === 'foodTruck' &&
                    <div style={{ ...details, marginTop: '-1px' }}>
                        <div>Special:</div><div style={{ fontWeight: '600' }}>{artista.cognome}</div>
                    </div>
                }
                {tipo === 'artisti' &&
                    <div style={{ ...details, marginTop: '-1px' }}>
                        <div>Comp. </div><div style={{ fontWeight: '600' }}>{artista.numero} {artista.numero > 1 ? 'elementi' : 'elemento'}</div>
                    </div>
                }
                {artista.regione &&
                    <div style={{ ...details, marginTop: '-1px' }}>
                        <div>Regione:</div><div style={{ fontWeight: '600' }}>{artista.regione}</div>
                    </div>
                }
                {artista.città &&
                    <div style={{ ...details, marginTop: '-1px' }}>
                        <div>Città:</div><div style={{ fontWeight: '600' }}>{artista.città}</div>
                    </div>
                }<hr />
                {/* ------------------------ DESCRIZIONE -------------------- */}
                <p ref={description} className='mt-1' /><hr />
                {tipo === 'artisti' && artista.durata &&
                    <div>
                        <div>Durata show:  <span style={{ fontWeight: '600' }}>{artista.durata}</span></div>
                        <hr />
                    </div>
                }
                {artista.cachet &&
                    <div style={{ ...details, marginTop: '-1px' }}>
                        <div>Cachet:</div> <div style={{ fontWeight: '600' }}>€ {artista.cachet}</div>
                    </div>
                }
                <div style={details}>
                    <div><img src={require("../../userNotAuth/image/icons8-nuovo-messaggio-48.png")} width={30} /></div>
                    <div style={{ fontWeight: '600' }}>{artista.emailUser}</div>
                </div>
                {artista.telefono !== '' &&
                    <div style={details} className='mt-2'>
                        <div><img src={require("../../userNotAuth/image/icons8-telefono-cellulare-48.png")} width={30} /></div>
                        <div style={{ fontWeight: '600' }}>{artista.telefono}</div>
                    </div>
                }

                {/* ----------------------------- VIDEO --------------------------- */}
                {artista.video &&
                    <div className='mt-3 text-center' style={{}}>
                        <video src={`https://leuro-bucket.s3.amazonaws.com/video/${artista.video}`} ref={videoPreview}
                            style={{ maxWidth: '100%', height: '250px' }} controls />
                    </div>
                }

                <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                    <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                    {artista.url &&
                        <div className='btn btn-warning'>
                            <a href={artista.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                        </div>
                    }
                    {artista.fb &&
                        <a href={artista.fb} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>
                            <img className='ms-1' src={require('../../userNotAuth/image/icons8-fb-48.png')} alt='' width={40} />
                        </a>
                    }
                    {artista.youtube &&
                        <a href={artista.youtube} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>
                            <img className='ms-1' src={require('../../userNotAuth/image/icons8-youtube-48.png')} alt='' width={40} />
                        </a>
                    }
                    {!artista.url && !artista.fb && !artista.youtube &&
                        <div>Nessun link presente </div>
                    }
                    {/* -------------------- IMMAGINI -------------------- */}
                </div>

                <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0' }}>
                    {foto.map((elem, index) => (
                        <div key={index} style={{ textAlign: 'center' }}>
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} style={{ maxWidth: '100px', height: '100px' }} alt="" />
                        </div>
                    ))}
                </div>

                <div className='mt-5'>
                    <button className='btn btn-secondary'
                        onClick={() => {
                            window.history.back()
                            if (artista.video) {
                                const lp = videoPreview.current
                                lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                            }
                        }}>⇐ Indietro
                    </button>
                    {tipo === 'artisti' ? <button className='ms-3 btn btn-primary' onClick={() => { dettagliIsOpen('artistaDetails', 'artisti') }}>Dettagli</button>
                        : ''}
                </div><br /><br />
            </div>
        </div>
        {artista.sezione === 'artista' && <ArtistiDetails artista={artista} flag2={flag} />}
    </>
    )
}

export default ChildArtisti